import React, { useState, useEffect } from 'react';
import Spinner from '../../../Spinner';
import powerlineIcon from '../../../../assets/icons/powerlines-legend-icon.png';

export default function Powerlines({ powerlines, latitude, longitude, map, powerlinesLoading, calculatePowerlineDistance, showPowerlinesPopup, parseWKTLine }) {
    const [isLayerVisible, setIsLayerVisible] = useState(true);

    // Sync checkbox state with actual layer visibility on mount
    useEffect(() => {
        if (map && map.current) {
            try {
                const layer = map.current.getLayer('Layer-powerlines');
                if (layer) {
                    const currentVisibility = map.current.getLayoutProperty('Layer-powerlines', 'visibility');
                    setIsLayerVisible(currentVisibility === 'visible');
                }
            } catch (error) {
                console.warn('Error checking powerlines layer visibility:', error);
            }
        }
    }, [map]);

    // Toggle layer visibility
    const toggleLayerVisibility = () => {
        const newVisibility = !isLayerVisible;
        setIsLayerVisible(newVisibility);
        
        if (map && map.current) {
            try {
                const layer = map.current.getLayer('Layer-powerlines');
                if (layer) {
                    map.current.setLayoutProperty('Layer-powerlines', 'visibility', newVisibility ? 'visible' : 'none');
                }
            } catch (error) {
                console.warn('Error toggling powerlines layer visibility:', error);
            }
        }
    };
    return (
        powerlinesLoading ?
            <div style={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '0.5rem', marginTop: '1.5rem' }}>
                <div style={{ fontSize: '0.8rem', color: 'white' }}>Searching for nearby powerlines potentially at risk...</div>
                <Spinner />
            </div>
            :     
            <div style={{ width: '100%', marginTop: '1rem', display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
                <div style={{ color: 'black', fontSize: '0.9rem', fontWeight: 'bold', display: 'flex', alignItems: 'center', gap: '0.3rem' }}>
                    <img src={powerlineIcon} style={{ width: '1rem' }}/>
                    Powerlines at risk ({powerlines ? powerlines.length : 0}):
                    <input
                        type="checkbox"
                        checked={isLayerVisible}
                        onChange={toggleLayerVisibility}
                        style={{
                            marginLeft: '0.5rem',
                            cursor: 'pointer',
                            transform: 'scale(1.1)'
                        }}
                    />
                </div>
                {(powerlines && powerlines.length > 0) ? (
                <div style={{ width: '100%', marginTop: '0.4rem' }}>
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                   <div style={{ maxHeight: '40vh', overflowY: 'auto', paddingBottom: '1rem' }}>
                     {powerlines
                       .sort((x, y) => calculatePowerlineDistance([longitude, latitude], x) - calculatePowerlineDistance([longitude, latitude], y))
                       .map((i, idx) => (
                       <div
                         key={idx}
                         style={{
                           display: 'flex',
                           flexDirection: 'column',
                           borderBottom: '1px solid rgba(88,88,88,0.8)',
                           padding: '0.8rem 0.4rem',
                           gap: '0.6rem',
                           marginBottom: idx === powerlines.length - 1 ? '1rem' : '0'
                         }}
                       >
                         <div style={{ display: 'flex', flexDirection: 'column', gap: '0.2rem' }}>
                           <div
                             style={{
                               color: 'black',
                               fontSize: '0.9rem',
                               fontWeight: 'bold'
                             }}
                           >
                             {i.SUB_1 ? i.SUB_1 : i.SUB_2 ? i.SUB_2 : i.id}
                           </div>
                           <div
                             style={{
                               color: '#666',
                               fontSize: '0.9rem',
                               marginTop: '0.2rem'
                             }}
                           >
                             {calculatePowerlineDistance([longitude, latitude], i).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} miles away from fire
                           </div>
                         </div>
                         <div
                           onClick={() => { 
                             map.current.flyTo({ center: parseWKTLine(i.wkt)[0], zoom: 18, pitch: 0 });
             
                             showPowerlinesPopup(parseWKTLine(i.wkt)[0], {
                               name: i.SUB_1 ? i.SUB_1 : i.SUB_2 ? i.SUB_2 : i.id,
                               type: i.TYPE,
                               status: i.STATUS,
                               distance: calculatePowerlineDistance([longitude, latitude], i)
                             }) 
                            }}
                           style={{
                             width: '100%',
                             display: 'flex',
                             alignItems: 'center',
                             justifyContent: 'center',
                             fontSize: '0.7rem',
                             color: 'white',
                             fontWeight: 'bold',
                             borderRadius: '7px',
                             padding: '0.3rem 0',
                             cursor: 'pointer',
                             backgroundColor: '#0080ff'
                           }}
                           onMouseEnter={(e) => {
                             e.target.style.backgroundColor = '#1668ba';
                           }}
                           onMouseLeave={(e) => {
                             e.target.style.backgroundColor = '#0080ff';
                           }}
                         >
                           View
                         </div>
                       </div>
                     ))}
                   </div>
                 </div>
               </div>
             ) : (
               <div style={{ 
                 display: 'flex', 
                 flexDirection: 'column', 
                 alignItems: 'center', 
                 justifyContent: 'center', 
                 padding: '2rem',
                 textAlign: 'center',
                 color: '#666',
                 marginTop: '1rem'
               }}>
                 <div style={{ fontSize: '1.1rem', fontWeight: 'bold', marginBottom: '0.5rem' }}>
                   No powerlines found
                 </div>
                 <div style={{ fontSize: '0.9rem' }}>
                   No powerlines at risk found in this area
                 </div>
               </div>
             )}
        </div>
    )
}
